module.exports = __webpack_public_path__ + "static/media/createBatchTam.bc4b45e8.jpg";